import React from "react";
import { InfoPage } from "./InfoPage";

const Media = () => (
  <InfoPage
    page="media"
    eyebrow="FOR PRESS & MEDIA"
    title="Press room: the story behind Prosper.AI."
    paragraphs={[
      "Prosper.AI is building the personal health intelligence layer that finally makes wearable data useful — one platform, every insight, real daily action.",
      "We share interviews, embargoed previews, brand assets, and feature briefings with credentialed press and creators. Reach out below and our team will follow up within one business day.",
    ]}
    ctaTitle="Reach our press team"
    ctaBody="Tell us about your outlet and the story you're working on — we'll respond fast."
    bullets={[
      { title: "Brand assets", body: "Logo lockups, product imagery, and approved screenshots on request." },
      { title: "Spokespeople", body: "Founders and clinical advisors available for interviews and quotes." },
      { title: "Embargoed previews", body: "Early previews of feature launches and partnership announcements." },
      { title: "Fact sheet", body: "Latest user numbers, integrations, and milestones — updated regularly." },
    ]}
  />
);

export default Media;
